import {Language} from "../i18n/translations";

export interface WinePickerWine {

}

export type AlgoliaWineCategory = 'Weisswein' | 'Rotwein' | 'Rosé' | 'Schaumwein' | 'Süsswein'
export interface AlgoliaWineGrapes {
    text: string | null | undefined
    grapes: string[]
}

export interface AlgoliaWine {
    objectID: string

    name: string
    nameFr: string | null | undefined
    nameIt: string | null | undefined

    description: string | null | undefined
    descriptionFr: string | null | undefined
    descriptionIt: string | null | undefined
    img_url: string | null | undefined

    // wine stuff
    category: AlgoliaWineCategory | null | undefined
    categoryFr: string | null | undefined
    categoryIt: string | null | undefined

    taste: number | null | undefined
    sweetness: number | null | undefined

    region: string | null | undefined
    regionFr: string | null | undefined
    regionIt: string | null | undefined
    country: string | null | undefined
    countryFr: string | null | undefined
    countryIt: string | null | undefined

    year: number | null | undefined
    alcoholContent: number | null | undefined

    closure: string | null | undefined
    closureFr: string | null | undefined
    closureIt: string | null | undefined

    outOfStock: boolean
    grapes: AlgoliaWineGrapes

    awards: string[]
    awardsFr: string[]
    awardsIt: string[]

    drinking_temperature: number[] | null | undefined
    appellation: string | null | undefined
    ageingContainer: boolean
    ageingTime: number | null | undefined

    // search relevant stuff
    recommendRanking: {
        [cluster: string]: number
    }
    nielsenRanking: {
        [cluster: string]: number
    }
    isDiscount: boolean
    discountRanking: number

    suitableFood: string[]
    suitableFoodFr: string[]
    suitableFoodIt: string[]

    collections: string[]
    collectionsFr: string[]
    collectionsIt: string[]

    producer: string | null | undefined
    bioVegan: ("bio" | "vegan")[]
    flags: string[]

    bottlesPerUnit: number
    delivery_unit: string | null | undefined
    delivery_unitFr: string | null | undefined
    delivery_unitIt: string | null | undefined
    bottle_size: number | null | undefined

    // pricing
    regular_price_per_bottle: number | null | undefined
    sale_price_per_bottle: number | null | undefined
}


export function algoliaWineCategorySortOrder(category: AlgoliaWineCategory | string) {
    switch (category) {
        case "Rosé":
            return 3;
        case "Rotwein":
            return 4;
        case "Schaumwein":
            return 1;
        case "Süsswein":
            return 5;
        case "Weisswein":
            return 2;
        default:
            return 6;
    }
}

export function getCategory(language: Language, wine: AlgoliaWine): string | null | undefined {
    switch (language) {
        case "de": return wine.category;
        case "fr": return wine.categoryFr ?? wine.category;
        case "it": return wine.categoryIt ?? wine.category;
    }
}

export function getName(language: Language, wine: AlgoliaWine): string {
    switch (language) {
        case "de": return wine.name;
        case "fr": return wine.nameFr ?? wine.name;
        case "it": return wine.nameIt ?? wine.name;
    }
}

export function getCountry(language: Language, wine: AlgoliaWine): string | null | undefined {
    switch (language) {
        case "de": return wine.country;
        case "fr": return wine.countryFr ?? wine.country;
        case "it": return wine.countryIt ?? wine.country;
    }
}

export function getRegion(language: Language, wine: AlgoliaWine): string | null | undefined {
    switch (language) {
        case "de": return wine.region;
        case "fr": return wine.regionFr ?? wine.region;
        case "it": return wine.regionIt ?? wine.region;
    }
}

export function getDescription(language: Language, wine: AlgoliaWine): string | null | undefined {
    switch (language) {
        case "de": return wine.description;
        case "fr": return wine.descriptionFr ?? wine.description;
        case "it": return wine.descriptionIt ?? wine.description;
    }
}

export function getSuitableFood(language: Language, wine: AlgoliaWine): string[] {
    switch (language) {
        case "de": return wine.suitableFood;
        case "fr": return wine.suitableFoodFr;
        case "it": return wine.suitableFoodIt;
    }
}